// src/styles/theme.ts

import { createTheme, ThemeOptions } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

// --- Module Augmentation for custom theme properties ---
// This allows us to add custom properties to the theme in a type-safe way.
declare module '@mui/material/styles' {
    // Allow configuration of the inverse palette
    interface PaletteOptions {
        inverse?: {
            main: string;
            contrastText: string;
            hover: {
                main: string;
            };
        };
    }
    // Allow use of the inverse palette
    interface Palette {
        inverse: {
            main: string;
            contrastText: string;
            hover: {
                main: string;
            };
        };
    }
}

// Common settings for both themes
const commonSettings: ThemeOptions = {
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none', // Remove uppercase text on buttons
                },
            },
        },
    },
};

// Light Theme
export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',
        },
        background: {
            default: '#f5f7fa', // Slightly off-white
            paper: '#ffffff',
        },
        // NEW: Inverse color palette for the light theme
        inverse: {
            main: '#000000',
            contrastText: '#ffffff',
            hover: {
                main: '#333333',
            },
        },
    },
    ...commonSettings,
});

// Dark Theme (Adjusted for a softer, more modern feel)
export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#90caf9', // A pleasant light blue for primary actions
        },
        background: {
            default: '#1c1c1e', // A softer, warmer black than pure #121212
            paper: '#2c2c2e',  // A slightly lighter grey for cards and surfaces
        },
        text: {
            primary: grey[50],
            secondary: grey[400],
        },
        // NEW: Inverse color palette for the dark theme
        inverse: {
            main: '#ffffff',
            contrastText: '#000000',
            hover: {
                main: '#e0e0e0',
            },
        },
    },
    ...commonSettings,
});